import styled from 'styled-components'
import Navbar from 'components/Navbar'

export const NavbarItem = styled.div`
  margin: 0 8px;
`

// This is used to align the action buttons on the canvas header
// with the rest of the elements. And also to adjust the spacing with
// the right separator
export const NavbarBackButtonItem = styled(NavbarItem)`
  margin: 0 8px 0 0;
  line-height: 1;
`

export const Close = styled.div`
  margin-left: 12px;
`

export const MobileFooterNavbar = styled(Navbar).attrs({
  alignItems: 'space-between',
})`
  border-top: 1px solid ${({ theme }) => theme.colors.border.A};
`
